module.exports = __webpack_public_path__ + "static/img/14000276.7c1f928c.png";